if (!customElements.get("back-in-stock-alert-drawer")) {
  customElements.define(
    "back-in-stock-alert-drawer",
    class BackInStockAlertDrawer extends HTMLElement {
      constructor() {
        super();

        const closeElementsSelectors = [
          ".back-in-stock-alert-close",
          ".back-in-stock-alert-overlay",
        ];

        this.querySelectorAll(closeElementsSelectors).forEach((closeEl) => {
          closeEl.addEventListener("click", () => {
            this.hide();
          });
        });

        this.openBtn = document.querySelector(".back-in-stock-alert-open-btn");

        this.openBtn?.addEventListener("click", (e) => {
          this.show(e.target);
        });
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        // remove other instances
        document
          .querySelectorAll("back-in-stock-alert-drawer")
          .forEach((el) => {
            if (el !== this) {
              el.remove();
            }
          });
        document
          .querySelectorAll(".back-in-stock-alert-open-btn")
          .forEach((btn) => {
            if (btn != this.openBtn) {
              btn.closest(".back-in-stock-alert")?.remove();
              btn?.remove();
            }
          });

        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        this.setOpenBtnStatus();

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const currentVariant = event.data.variant;
            this.resetStatus();
            this.updateInfo(currentVariant);
          }
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");

        this.addEventListener(
          "transitionend",
          () => {
            trapFocus(this, this.querySelector('[role="dialog"]'));
          },
          { once: true }
        );
      }

      setOpenBtnStatus() {
        const params = new URLSearchParams(window.location.search);
        const hash = window.location.hash;

        if (
          params.get("contact_posted") === "true" &&
          hash.includes("#BackInStockAlertForm-")
        ) {
          const match = hash.match(/#(BackInStockAlertForm-[\w\-]+)/);
          if (match && match[1]) {
            const form_id = match[1];
            const buttonId = `Button-${form_id}`;
            const button = document.getElementById(buttonId);

            if (button) {
              button.dataset.status = "success";
            }
          }
        }
      }

      updateInfo(currentVariant) {
        const formattedOptions =
          currentVariant.options.length > 1
            ? currentVariant.options.join(", ")
            : currentVariant.options[0] || "";

        const optionsEl = this.querySelector(
          ".back-in-stock-alert-product-options"
        );
        const inputOptions = this.querySelector("#BackInStockAlert-options");

        if (optionsEl) optionsEl.textContent = formattedOptions;
        if (inputOptions) inputOptions.value = formattedOptions;

        const inputReturn = this.querySelector("#BackInStockAlert-return");

        if (inputReturn && inputReturn.value.includes("variant=")) {
          const baseUrl = this.productUrl || inputReturn.value.split("?")[0];
          inputReturn.value = `${baseUrl}?variant=${currentVariant.id}&contact_posted=true`;
        }
      }

      updateProduct({ title, url } = {}) {
        if (title) {
          const titleEl = this.querySelector(
            ".back-in-stock-alert-product-title"
          );
          if (titleEl) titleEl.textContent = title;

          const inputProduct = this.querySelector("#BackInStockAlert-product");
          if (inputProduct) inputProduct.value = title;
        }

        if (url) {
          this.productUrl = url;
        }
      }

      resetStatus() {
        const messages = this.querySelectorAll(".form-message");
        messages.forEach((el) => el.remove());

        if (this.openBtn) {
          this.openBtn.dataset.status = "false";
        }
      }
    }
  );
}
